import React from 'react';
import { Text, Theme, localizationMaps, i18n, tokens } from '@simplybenefits/sb-ui-library';
import store from "../../redux/store";
import { numberWithCommas } from "../../services/helpers";

/**
 * Fetches the correct pre determined offset for fully used items
 * @param limitText
 */
const getLimitTextOffset = (limitText) => {
    if (limitText === "1 Unit") {
        return 'calc(100% - 50px)';
    } else if (limitText === 'Unlimited') {
        return 'calc(100% - 70px)';
    } else if (limitText === 'Refer to your Booklet') {
        return 'calc(100% - 146px)';
    }
 
    return 'calc(100% - 75px)';
    
};

/**
 * @param usage
 * @param bottom
 * @param classes
 * @param notDollar
 * @param extraText
 * @param color
 * @returns {*}
 * @constructor
 */
const UsageBlock = ({ usage, bottom, notDollar, extraText = '', fillColor = 'skyBlue', limitText = false, showRemaining = false }) => {
    const whitelabel = store.getState().whitelabel;
    let progress = (usage.used / usage.limit) * 100;

    let color = whitelabel.primaryColor || Theme.colors[fillColor];

    if (progress === 0) {
        color = Theme.colors.lightGrey;
        progress = 50;
    }

    if (progress < 20) {
        progress = 20;
    }

    if (isNaN(progress)) {
        progress = 100;
    }

    if (usage.limit === 0) {
        progress = 0;
    }

    let rightHandText = limitText ? limitText : notDollar ? `${ usage.limit } ${ extraText }` : `$${ numberWithCommas(usage.limit) } ${ extraText }`;

    const styles = {
        row: {
            display: 'flex',
            flex: 1,
            height: 80,
            flexDirection: 'column',
            justifyContent: 'center',
            borderTop: `1px solid ${ Theme.colors.lightGrey }`
        },
        rowBottomBorder: {
            borderBottom: `1px solid ${ Theme.colors.lightGrey }`
        },
        progressBarContainer: {
            display: 'flex',
            flexDirection: 'row',
            borderRadius: 20,
            height: 25,
            backgroundColor: Theme.colors.lightGrey,
            marginBottom: 5,
            position: 'relative'
        }
    };

    return (
        <div style={ bottom ? { ...styles.row, ...styles.rowBottomBorder } : styles.row } >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                <Text
                    medium
                    light
                    margin="0 0 5px 0"
                >
                    { localizationMaps.fromEnglish("benefits", usage.type.trim()) }
                </Text>

                {
                    (showRemaining && usage.used > 0) &&
                        <Text small light margin={'0 15px 0 0'} align="right">
                            { i18n.t(tokens.labels.amountRemaining, { amount: numberWithCommas((usage.limit - usage.used).toFixed(2)) })}
                        </Text>
                }
            </div>

            <div style={ styles.progressBarContainer }>
                <div style={{ display: 'flex', flex: 1, flexDirection: 'row' }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: color,
                        width: `${ progress }%`,
                        height: 25,
                        paddingLeft: 10,
                        borderRadius: 20
                    }}>
                        <Text
                            small
                            color={Theme.colors.surface}
                            bold
                            margin="0px 5px"
                        >
                            { notDollar ? usage.used : (Number(usage.used) > 0 ? `$${ numberWithCommas(usage.used) }` : `$${ usage.used }`) }
                        </Text>
                    </div>
                </div>

                <Text
                    small
                    color={Number(usage.used) > (Number(usage.limit) * 0.9) ? Theme.colors.surface : Theme.colors.mainTextGrey }
                    margin="2px 15px 0 -5px"
                    customStyle={Number(usage.used) > (Number(usage.limit) * 0.9)
                        ?
                        {
                            position: 'absolute',
                            left: limitText ? getLimitTextOffset(limitText) : usage.limit < 999 ? 'calc(100% - 60px)' : 'calc(100% - 70px)'
                        }
                        : null}
                >
                    { rightHandText }
                </Text>
            </div>
        </div>
    );
};

export default UsageBlock;